<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="allMonthQuotationType"
              item-text="Name"
              item-value="Type"
              :label="$t('quotation_name')"
              v-model="filterMonthQuotation.Type"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              :loading="isLoading"
              @change="getMonthQuotation"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_number')"
              v-model="filterMonthQuotation.Number"
              @input="getMonthQuotation"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterOriginalCustomer"
              :editedCustomerIndex="-1"
              :customerName="'quotation_original_customer_number'"
              @setFilterCustomer="setFilterOriginalCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_original_license_plate')"
              v-model="filterMonthQuotation.OriginalLicensePlate"
              @input="getMonthQuotation"
            ></v-text-field>
          </v-col>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterCustomer"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterMonthQuotation.LicensePlate"
              @input="getMonthQuotation"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="filterMonthQuotation.IsThrowMonth"
              label="轉拋?"
              @change="getMonthQuotation"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="monthQuotationDataTableHeaders"
      :items="monthQuotationList"
      class="elevation-1 mt-5"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :loading="isLoading"
      :loading-text="$t('common_get_data')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('quotation_tool_bar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            @click="isShowChangeDetailPageDialog = true"
          >
            變更車牌、抬頭頁面
          </v-btn>
          <v-dialog persistent v-model="isShowChangeDetailPageDialog" fullscreen>
            <v-card>
              <v-card-title>變更車牌、抬頭頁面</v-card-title>
              <change-detail />
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="isShowChangeDetailPageDialog = false">
                  {{ $t('common_close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            @click="isShowEditMonthQuotationDialog = true"
          >
            {{ $t('quotation_new_btn') }}
          </v-btn>
          <v-dialog
            persistent
            v-model="isShowEditMonthQuotationDialog"
            v-if="isShowEditMonthQuotationDialog"
            fullscreen
          >
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ monthQuotationDialogTitle }}</span>
                <v-spacer></v-spacer>
                <v-btn text small @click="closeEditedMonthQuotation" class="mx-2">
                  <v-icon>
                    mdi-close-circle-outline
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <!--Start 月租報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    :disabled="
                      editedMonthQuotationIndex === -1 || editedMonthQuotation.IsThrowMonth
                    "
                    class="mx-2"
                    @click="throwMonth"
                    v-if="editedMonthQuotation.Type !== monthQuotationType.UnlimitedMonth"
                  >
                    拋轉月租
                  </v-btn>
                  <!--End 月租報價單才有的Btn -->
                  <v-btn
                    fab
                    small
                    class="mx-2"
                    color="green darken-1"
                    text
                    @click="saveEditedMonthQuotation"
                    :loading="isLoadingSaveBtn"
                    :disabled="isAllTextFieldDisabled || editedMonthQuotation.IsThrowMonth"
                  >
                    <v-icon>
                      mdi-content-save
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    text
                    small
                    color="primary"
                    :disabled="editedMonthQuotationIndex === -1 || isLoadingSaveBtn"
                    @click="copyMonthQuotation"
                  >
                    <v-icon>
                      mdi-content-copy
                    </v-icon>
                  </v-btn>
                </v-row>
              </v-card-text>
              <v-tabs>
                <v-tab href="#tab-1">{{ $t('quotation_tab_first') }}</v-tab>
                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-container>
                        <ValidationObserver ref="dialog">
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_name')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  v-model="editedMonthQuotation.Type"
                                  :items="allMonthQuotationType"
                                  item-text="Name"
                                  item-value="Type"
                                  :error-messages="errors[0]"
                                  :disabled="
                                    editedMonthQuotationIndex !== -1 || isAllTextFieldDisabled
                                  "
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :loading="isLoading"
                                  @keyup.enter="setTypeAutocomplete"
                                  ref="typeAutocomplete"
                                  return-object
                                  @change="setRemovedReason"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_name') }}
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedMonthQuotationIndex !== -1"
                            >
                              <v-text-field
                                v-model="editedMonthQuotation.Number"
                                disabled
                                :label="$t('quotation_number')"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="
                                editedMonthQuotation.Type !== monthQuotationType.RemoveMonth &&
                                  editedMonthQuotation.Type !== monthQuotationType.RenewMonth
                              "
                            >
                              <date-picker-set-time
                                :time="editedMonthQuotation.MonthDoneTime"
                                :dateName="'month_quotation_done_time'"
                                :isAllTextFieldDisabled="isAllTextFieldDisabled"
                                @setDate="setMonthDoneTime"
                                @keyupEnter="focusNextInput"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="
                                editedMonthQuotation.Type === monthQuotationType.RemoveMonth ||
                                  editedMonthQuotation.Type === monthQuotationType.MoveMonth
                              "
                            >
                              <date-picker-set-time
                                :time="editedMonthQuotation.MonthSignTime"
                                :dateName="'month_quotation_sign_time'"
                                :isAllTextFieldDisabled="isAllTextFieldDisabled"
                                @setDate="setMonthSignTime"
                                @keyupEnter="focusNextInput"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedMonthQuotation.Type === monthQuotationType.RenewMonth"
                            >
                              <date-picker-set-time
                                :time="editedMonthQuotation.RenewMonthTime"
                                :dateName="'month_quotation_renew_time'"
                                :isAllTextFieldDisabled="isAllTextFieldDisabled"
                                @setDate="setRenewMonthTime"
                                @keyupEnter="focusNextInput"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-card
                              min-width="100%"
                              elevation="1"
                              v-if="
                                editedMonthQuotation.Type === monthQuotationType.ReturnMonth ||
                                  editedMonthQuotation.Type === monthQuotationType.MoveMonth ||
                                  editedMonthQuotation.Type === monthQuotationType.RenewMonth
                              "
                            >
                              <v-card-title>
                                拆機客戶
                              </v-card-title>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="3">
                                    <quotation-customer-autocomplete
                                      refName="customerAutocomplete"
                                      @keyupEnter="focusNextInput"
                                      :fatherEditedCustomer="editedMonthQuotation.OriginalCustomer"
                                      :editedCustomerIndex="-1"
                                      :customerName="'quotation_customer_number'"
                                      @setCustomer="setOriginalCustomer"
                                      :isAllTextFieldDisable="isAllTextFieldDisabled"
                                    />
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_shortname')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="editedMonthQuotation.OriginalCustomer.ShortName"
                                        :error-messages="errors[0]"
                                        disabled
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_shortname') }}
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_full_name')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="editedMonthQuotation.OriginalCustomer.FullName"
                                        :error-messages="errors[0]"
                                        disabled
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_full_name') }}
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                </v-row>
                                <v-row
                                  v-if="editedMonthQuotation.Type === monthQuotationType.MoveMonth"
                                >
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedMonthQuotation.OriginalCustomer.Tel"
                                      :label="$t('quotation_tel')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedMonthQuotation.OriginalCustomer.Fax"
                                      :label="$t('quotation_fax')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedMonthQuotation.OriginalCustomer.Attribute"
                                      :label="$t('quotation_attribute')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedMonthQuotation.OriginalCustomer.InvoiceAddress"
                                      :label="$t('quotation_invoice_address')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-row>
                          <v-row>
                            <v-card
                              min-width="100%"
                              elevation="1"
                              :class="
                                editedMonthQuotation.Type === monthQuotationType.ReturnMonth ||
                                editedMonthQuotation.Type === monthQuotationType.MoveMonth ||
                                editedMonthQuotation.Type === monthQuotationType.RenewMonth
                                  ? 'my-5'
                                  : 'mb-5'
                              "
                            >
                              <v-card-title
                                v-if="
                                  editedMonthQuotation.Type === monthQuotationType.ReturnMonth ||
                                    editedMonthQuotation.Type === monthQuotationType.MoveMonth ||
                                    editedMonthQuotation.Type === monthQuotationType.RenewMonth
                                "
                              >
                                回裝客戶
                              </v-card-title>
                              <v-card-title v-else>
                                客戶資料
                              </v-card-title>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="3">
                                    <quotation-customer-autocomplete
                                      refName="customerAutocomplete"
                                      @keyupEnter="focusNextInput"
                                      :fatherEditedCustomer="editedMonthQuotation.Customer"
                                      :editedCustomerIndex="-1"
                                      :customerName="'quotation_customer_number'"
                                      @setCustomer="setCustomer"
                                      :isAllTextFieldDisable="isAllTextFieldDisabled"
                                    />
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_shortname')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="editedMonthQuotation.Customer.ShortName"
                                        :error-messages="errors[0]"
                                        disabled
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_shortname') }}
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_full_name')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="editedMonthQuotation.Customer.FullName"
                                        :error-messages="errors[0]"
                                        disabled
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_full_name') }}
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedMonthQuotation.Customer.Tel"
                                      :label="$t('quotation_tel')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedMonthQuotation.Customer.Fax"
                                      :label="$t('quotation_fax')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedMonthQuotation.Customer.Attribute"
                                      :label="$t('quotation_attribute')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedMonthQuotation.Customer.InvoiceAddress"
                                      :label="$t('quotation_invoice_address')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="
                                editedMonthQuotation.Type !== monthQuotationType.NewMonth &&
                                  editedMonthQuotation.Type !== monthQuotationType.RenewMonth &&
                                  editedMonthQuotation.Type !== monthQuotationType.UnlimitedMonth
                              "
                            >
                              <ValidationProvider
                                :name="$t('quotation_license_plate')"
                                :rules="{ max: 13 }"
                                v-slot="{ errors }"
                              >
                                <v-combobox
                                  :items="customerLicensePlateList"
                                  item-text="LicensePlate"
                                  item-value="LicensePlate"
                                  v-model.trim="editedMonthQuotation.LicensePlate"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :label="$t('quotation_license_plate')"
                                  :disabled="isAllTextFieldDisabled"
                                  :error-messages="errors[0]"
                                  :return-object="false"
                                  @change="searchMonthForLicensePlate"
                                  @click="getCustomerLicensePlateList"
                                >
                                  <template v-slot:item="data">
                                    <template>
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          {{ data.item.LicensePlate }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                          {{ $t('quotation_shortname') }} :
                                          {{ data.item.CustomerName }}
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle>
                                          {{ $t('quotation_full_name') }} :
                                          {{ data.item.CustomerFullName }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </template>
                                </v-combobox>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="
                                editedMonthQuotation.Type === monthQuotationType.ReturnMonth ||
                                  editedMonthQuotation.Type === monthQuotationType.MoveMonth
                              "
                            >
                              <ValidationProvider
                                :name="$t('quotation_original_license_plate')"
                                :rules="{ max: 13 }"
                                v-slot="{ errors }"
                              >
                                <v-combobox
                                  :items="customerOriginalLicensePlateList"
                                  item-text="LicensePlate"
                                  item-value="LicensePlate"
                                  v-model.trim="editedMonthQuotation.OriginalLicensePlate"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :label="$t('quotation_original_license_plate')"
                                  :disabled="isAllTextFieldDisabled"
                                  @change="searchMonthForOriginalLicensePlate"
                                  :error-messages="errors[0]"
                                  @click="getCustomerOriginalLicenseLicensePlateList"
                                  :return-object="false"
                                >
                                  <template v-slot:item="data">
                                    <template>
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          {{ data.item.LicensePlate }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                          {{ $t('quotation_shortname') }} :
                                          {{ data.item.CustomerName }}
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle>
                                          {{ $t('quotation_full_name') }} :
                                          {{ data.item.CustomerFullName }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </template>
                                </v-combobox>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedMonthQuotation.Type === monthQuotationType.RenewMonth"
                            >
                              <ValidationProvider
                                :name="$t('quotation_original_license_plate')"
                                :rules="{ max: 13 }"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  :items="customerOriginalLicensePlateList"
                                  item-text="LicensePlate"
                                  item-value="LicensePlate"
                                  v-model.trim="editedMonthQuotation.OriginalLicensePlate"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :label="$t('quotation_original_license_plate')"
                                  :disabled="isAllTextFieldDisabled"
                                  @change="searchMonthForOriginalLicensePlate"
                                  :error-messages="errors[0]"
                                  @click="getCustomerOriginalLicenseLicensePlateList"
                                >
                                  <template v-slot:item="data">
                                    <template>
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          {{ data.item.LicensePlate }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                          {{ $t('quotation_shortname') }} :
                                          {{ data.item.CustomerName }}
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle>
                                          {{ $t('quotation_full_name') }} :
                                          {{ data.item.CustomerFullName }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedMonthQuotation.Type === monthQuotationType.RenewMonth"
                            >
                              <ValidationProvider
                                :name="$t('quotation_license_plate')"
                                :rules="{ max: 13 }"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  :items="customerLicensePlateList"
                                  item-text="LicensePlate"
                                  item-value="LicensePlate"
                                  v-model.trim="editedMonthQuotation.LicensePlateList"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :label="$t('quotation_license_plate')"
                                  :disabled="isAllTextFieldDisabled"
                                  :error-messages="errors[0]"
                                  @change="searchMonthForLicensePlate"
                                  @click="getCustomerLicensePlateList"
                                  small-chips
                                  multiple
                                >
                                  <template v-slot:item="data">
                                    <template>
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          {{ data.item.LicensePlate }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                          {{ $t('quotation_shortname') }} :
                                          {{ data.item.CustomerName }}
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle>
                                          {{ $t('quotation_full_name') }} :
                                          {{ data.item.CustomerFullName }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthQuotation.Customer.Tel"
                                :label="$t('quotation_tel')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthQuotation.Customer.Fax"
                                :label="$t('quotation_fax')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthQuotation.Customer.Attribute"
                                :label="$t('quotation_attribute')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthQuotation.Customer.InvoiceAddress"
                                :label="$t('quotation_invoice_address')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="
                                editedMonthQuotation.Type === monthQuotationType.RemoveMonth ||
                                  editedMonthQuotation.Type === monthQuotationType.MoveMonth
                              "
                            >
                              <ValidationProvider
                                :name="$t('quotation_removed_reason')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  v-model="editedMonthQuotation.RemovedReason"
                                  :items="allRemovedReason"
                                  :label="$t('quotation_removed_reason')"
                                  item-text="Name"
                                  item-value="Type"
                                  :disabled="isAllTextFieldDisabled"
                                  :error-messages="errors[0]"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :loading="isLoading"
                                  @keyup.enter="setRemovedReasonAutocomplete"
                                  ref="removedReasonAutocomplete"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_removed_reason') }}
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedMonthQuotation.Type === monthQuotationType.NewMonth"
                            >
                              <ValidationProvider
                                :name="$t('quotation_license_plate')"
                                :rules="{ max: 13 }"
                                v-slot="{ errors }"
                              >
                                <v-combobox
                                  v-model.trim="editedMonthQuotation.LicensePlateList"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :label="$t('quotation_license_plate')"
                                  :disabled="isAllTextFieldDisabled"
                                  multiple
                                  small-chips
                                  @change="setCarQuantity"
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:append-outer>
                                    <LicensePlateBatchInputButton
                                      :value="editedMonthQuotation.LicensePlateList"
                                      :disabled="isAllTextFieldDisabled"
                                      @input="onBatchInputLicensePlate"
                                    />
                                  </template>
                                </v-combobox>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                      </v-container>
                    </v-card-text>
                  </v-card>
                  <new-car
                    v-if="editedMonthQuotation.Type === monthQuotationType.NewMonth"
                    :isAllTextFieldDisabled="isAllTextFieldDisabled"
                    :carQuantity="editedMonthQuotation.CarQuantity"
                    :monthItemList="editedMonthQuotation.MonthItems"
                    :discountItemList="editedMonthQuotation.DiscountItems"
                    :allPayType="allPayType"
                    :allPayQuantityType="allPayQuantityType"
                    @setAllMonth="setAllMonth"
                    @setMonthItemIndex="setMonthItemIndex"
                    @setMonthItem="setMonthItem"
                    @deleteMonthItem="deleteMonthItem"
                    @setMonthBomItemIndex="setMonthBomItemIndex"
                    @setBomMonth="setBomMonth"
                    @setDiscountItem="setDiscountItem"
                    @setDiscountItemIndex="setDiscountItemIndex"
                    @deleteDiscountItem="deleteDiscountItem"
                    @setAllDiscount="setAllDiscount"
                  />
                  <remove-car
                    v-if="editedMonthQuotation.Type === monthQuotationType.RemoveMonth"
                    :isAllTextFieldDisabled="isAllTextFieldDisabled"
                    :carQuantity="editedMonthQuotation.CarQuantity"
                    :monthItemList="editedMonthQuotation.MonthItems"
                    :discountItemList="editedMonthQuotation.DiscountItems"
                    :allPayType="allPayType"
                    :allPayQuantityType="allPayQuantityType"
                    @setAllMonth="setAllMonth"
                    @setMonthItemIndex="setMonthItemIndex"
                    @setMonthItem="setMonthItem"
                    @deleteMonthItem="deleteMonthItem"
                  />

                  <return-car
                    v-if="editedMonthQuotation.Type === monthQuotationType.ReturnMonth"
                    :isAllTextFieldDisabled="isAllTextFieldDisabled"
                    :carQuantity="editedMonthQuotation.CarQuantity"
                    :monthItemList="editedMonthQuotation.MonthItems"
                    :discountItemList="editedMonthQuotation.DiscountItems"
                    :allPayType="allPayType"
                    :allPayQuantityType="allPayQuantityType"
                    :repairCustomerId="editedMonthQuotation.Customer.Id"
                    @setAllMonth="setAllMonth"
                    @setMonthItemIndex="setMonthItemIndex"
                    @setMonthItem="setMonthItem"
                    @deleteMonthItem="deleteMonthItem"
                    @setMonthBomItemIndex="setMonthBomItemIndex"
                    @setBomMonth="setBomMonth"
                    @setDiscountItem="setDiscountItem"
                    @setDiscountItemIndex="setDiscountItemIndex"
                    @deleteDiscountItem="deleteDiscountItem"
                    @setAllDiscount="setAllDiscount"
                  />

                  <move-car
                    v-if="editedMonthQuotation.Type === monthQuotationType.MoveMonth"
                    :isAllTextFieldDisabled="isAllTextFieldDisabled"
                    :carQuantity="editedMonthQuotation.CarQuantity"
                    :monthItemList="editedMonthQuotation.MoveMonthItems"
                    :discountItemList="editedMonthQuotation.DiscountItems"
                    :allPayType="allPayType"
                    :allPayQuantityType="allPayQuantityType"
                    :repairCustomerId="editedMonthQuotation.Customer.Id"
                    @setAllMoveMonth="setAllMoveMonth"
                    @setMonthItemIndex="setMonthItemIndex"
                    @setMoveMonthItem="setMoveMonthItem"
                    @deleteMoveMonthItem="deleteMoveMonthItem"
                    @setDiscountItem="setDiscountItem"
                    @setDiscountItemIndex="setDiscountItemIndex"
                    @deleteDiscountItem="deleteDiscountItem"
                    @setAllDiscount="setAllDiscount"
                  />

                  <discount
                    v-if="editedMonthQuotation.Type === monthQuotationType.Discount"
                    :isAllTextFieldDisabled="isAllTextFieldDisabled"
                    :carQuantity="editedMonthQuotation.CarQuantity"
                    :monthItemList="editedMonthQuotation.MonthItems"
                    :discountItemList="editedMonthQuotation.DiscountItems"
                    :allPayType="allPayType"
                    @setDiscountItem="setDiscountItem"
                    @setDiscountItemIndex="setDiscountItemIndex"
                    @deleteDiscountItem="deleteDiscountItem"
                    @setAllDiscount="setAllDiscount"
                  />

                  <renew-month-setting
                    v-if="editedMonthQuotation.Type === monthQuotationType.RenewMonth"
                    :isAllTextFieldDisabled="isAllTextFieldDisabled"
                    :carQuantity="editedMonthQuotation.CarQuantity"
                    :monthItemList="editedMonthQuotation.MonthItems"
                    :allPayType="allPayType"
                    :allPayQuantityType="allPayQuantityType"
                    :renewMonthItemList="editedMonthQuotation.RenewMonthItems"
                    :repairCustomerId="editedMonthQuotation.Customer.Id"
                    @setMonthItemIndex="setMonthItemIndex"
                    @setMonthItem="setMonthItem"
                    @deleteRenewMonthItem="deleteRenewMonthItem"
                    @setEditedRenewMonthItemIndex="setEditedRenewMonthItemIndex"
                    @setEditedRenewMonthItem="setEditedRenewMonthItem"
                  />

                  <unlimited-month
                    v-if="editedMonthQuotation.Type === monthQuotationType.UnlimitedMonth"
                    :isAllTextFieldDisabled="isAllTextFieldDisabled"
                    :carQuantity="editedMonthQuotation.CarQuantity"
                    :monthItemList="editedMonthQuotation.MonthItems"
                    :allPayType="allPayType"
                    :allPayQuantityType="allPayQuantityType"
                    @setAllMonth="setAllMonth"
                    @setMonthItemIndex="setMonthItemIndex"
                    @setMonthItem="setMonthItem"
                    @deleteMonthItem="deleteMonthItem"
                  />
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedMonthQuotation"
                  :disabled="isLoadingSaveBtn"
                >
                  {{ $t('common_close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisabled"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteMonthQuotationDialog"
            :deleteMessage="'quotation_delete_dialog_title'"
            @closeDelete="closeDeleteMonthQuotation"
            @confirmDelete="confirmDeleteMonthQuotation"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Customer`]="{ item }">
        {{ item.Customer.Number }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditMonthQuotationDialogBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn icon @click="isShowDeleteMonthQuotationDialogBtn(item)">
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.LicensePlateList`]="{ item }">
        <div v-if="item.LicensePlateList.length > 2">
          <v-chip v-for="index in 2" :key="index" small>
            {{ item.LicensePlateList[index - 1] }}
          </v-chip>
          +({{ item.LicensePlateList.length - 2 }})
        </div>
        <div v-else>
          <v-chip v-for="licensePlate in item.LicensePlateList" :key="licensePlate" small>
            {{ licensePlate }}
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.Type`]="{ item }">
        {{ turnTypeName(item.Type) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { MonthQuotationType } from '@/js/MonthQuotationType'
import {
  HttpQuotation,
  HttpMonthQuotation,
  HttpMonth,
  HttpDiscount,
  HttpOverage
} from '@/js/http-Manager'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import DatePickerSetTime from '@/components/DatePickerSetTime.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import QuotationCustomerAutocomplete from '@/components/QuotationCustomerAutocomplete.vue'
import NewCar from '@/components/MonthQuotation/NewCar.vue'
import RemoveCar from '@/components/MonthQuotation/RemoveCar.vue'
import ReturnCar from '@/components/MonthQuotation/ReturnCar.vue'
import MoveCar from '@/components/MonthQuotation/MoveCar.vue'
import ChangeDetail from '@/components/ChangeDetail/ChangeDetail.vue'
import Discount from '../components/MonthQuotation/Discount.vue'
import RenewMonthSetting from '../components/Quotation/MonthItem/RenewMonthSetting.vue'
import UnlimitedMonth from '@/components/MonthQuotation/UnlimitedMonth.vue'
import LicensePlateBatchInputButton from '@/components/ChangeDetail/LicensePlateBatchInputButton.vue'
import { PayType } from '@/js/PayType'
export default {
  components: {
    CustomerAutocompleteFilter,
    QuotationCustomerAutocomplete,
    DeleteDialog,
    DatePickerSetTime,
    NewCar,
    RemoveCar,
    ReturnCar,
    MoveCar,
    ChangeDetail,
    Discount,
    LicensePlateBatchInputButton,
    RenewMonthSetting,
    UnlimitedMonth
  },
  name: 'MonthQuotation',
  data: () => ({
    payType: PayType,
    monthQuotationType: MonthQuotationType,
    renewMonthItemIndex: -1,
    filterCustomer: {
      CustomerId: ''
    },
    filterOriginalCustomer: {
      CustomerId: ''
    },
    isShowEditMonthQuotationDialog: false,
    isShowDeleteMonthQuotationDialog: false,
    monthQuotationList: [],
    editedMonthQuotationIndex: -1,
    monthBomItemIndex: -1,
    editedMonthQuotation: {
      Type: 0,
      Number: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      OriginalCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      CarQuantity: 1,
      RemovedReason: 0,
      LicensePlate: '',
      LicensePlateList: [],
      OriginalLicensePlate: '',
      MonthItems: [],
      MoveMonthItems: [],
      DiscountItems: [],
      RenewMonthItems: [],
      IsThrowMonth: false,
      MonthDoneTime: 0,
      MonthSignTime: 0,
      RenewMonthTime: 0
    },
    defaultMonthQuotation: {
      Type: 0,
      Number: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      OriginalCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      CarQuantity: 1,
      RemovedReason: 0,
      LicensePlate: '',
      LicensePlateList: [],
      OriginalLicensePlate: '',
      MonthItems: [],
      MoveMonthItems: [],
      DiscountItems: [],
      RenewMonthItems: [],
      IsThrowMonth: false,
      MonthDoneTime: 0,
      MonthSignTime: 0,
      RenewMonthTime: 0
    },
    allMonthQuotationType: [],
    allRemovedReason: [],
    filterMonthQuotation: {
      Type: 0,
      Number: '',
      CustomerId: '',
      OriginalCustomerId: '',
      LicensePlate: '',
      OriginalLicensePlate: '',
      IsThrowMonth: false
    },
    isLoading: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisabled: false,
    totalRows: 0,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    allPayType: [],
    customerOriginalLicensePlateList: [],
    customerLicensePlateList: [],
    warningMessage: [],
    isShowChangeDetailPageDialog: false,
    allPayQuantityType: []
  }),
  async mounted () {
    await this.getMonthQuotationType()
    await this.getRemoveReason()
    await this.getMonthQuotation()
    await this.countTotalRows()
    await this.getAllPayType()
    await this.getAllPayQuantityType()
  },
  watch: {},
  computed: {
    monthQuotationDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_name'),
          align: 'start',
          value: 'Type'
        },
        { text: this.$t('quotation_number'), align: 'start', value: 'Number' },
        {
          text: '原' + this.$t('quotation_customer_number'),
          align: 'center',
          value: 'OriginalCustomer.Number'
        },
        {
          text: '原' + this.$t('quotation_shortname'),
          align: 'center',
          value: 'OriginalCustomer.ShortName'
        },
        {
          text: '原' + this.$t('quotation_full_name'),
          align: 'center',
          value: 'OriginalCustomer.FullName'
        },
        {
          text: this.$t('quotation_customer_number'),
          align: 'center',
          value: 'Customer.Number'
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'center',
          value: 'Customer.ShortName'
        },
        {
          text: this.$t('quotation_full_name'),
          align: 'center',
          value: 'Customer.FullName'
        },
        {
          text: this.$t('quotation_license_plate'),
          align: 'center',
          value: 'LicensePlate'
        },
        {
          text: this.$t('quotation_license_plate') + '清單',
          align: 'center',
          value: 'LicensePlateList'
        },
        {
          text: this.$t('quotation_original_license_plate'),
          align: 'center',
          value: 'OriginalLicensePlate'
        },
        {
          text: '轉拋?',
          align: 'center',
          value: 'IsThrowMonth'
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    monthQuotationDialogTitle () {
      return this.editedMonthQuotationIndex === -1
        ? this.$t('quotation_new_dialog_title')
        : this.$t('quotation_edit_dialog_title')
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    async getAllPayQuantityType () {
      let response = await HttpMonth.GetAllPayQuantityType()
      if (response && response.status === 200) {
        this.allPayQuantityType = response.data.Data
      }
    },
    async getUnlimitedMonthList () {
      let monthResponse = await HttpMonth.GetUnlimitedMonthList({
        customerId: this.editedMonthQuotation.Customer.Id
      })
      if (monthResponse && monthResponse.status === 200) {
        this.editedMonthQuotation.MonthItems = []
        monthResponse.data.Data.forEach((element) => {
          let temp = {
            Id: element.ItemId,
            Number: element.ItemNumber,
            Name: element.ItemName,
            MonthNumber:
              this.editedMonthQuotation.Type === this.monthQuotationType.Discount
                ? ''
                : element.Number,
            Unit: element.ItemUnit,
            DiscountPrice: element.OriginalCurrency * 1,
            Discount: 0,
            PayQuantity: element.PayQuantity * 1,
            StopPayQuantity: 0,
            AddPayQuantity: 0,
            PayQuantityType: element.PayQuantityType,
            Quantity: element.OverageMonthQuantity * 1,
            RentQuantity: 1,
            Price: element.OriginalCurrency * 1,
            TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
            RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
            PayType: element.PayType,
            Remark: element.Remark,
            PayTimeRangeType: element.PayTimeRangeType,
            LicensePlate: element.LicensePlate
          }
          this.editedMonthQuotation.MonthItems.push(temp)
        })
      }
    },
    async searchMonthForLicensePlate () {
      if (
        this.editedMonthQuotation.Type === this.monthQuotationType.RemoveMonth ||
        this.editedMonthQuotation.Type === this.monthQuotationType.Discount
      ) {
        let param = {
          customerId: this.editedMonthQuotation.Customer.Id,
          licensePlate: this.editedMonthQuotation.LicensePlate
        }

        let monthResponse = await HttpMonth.GetMonthList(param)
        let tempMonthItems = this.editedMonthQuotation.MonthItems
        if (monthResponse && monthResponse.status === 200) {
          this.editedMonthQuotation.MonthItems = []
          monthResponse.data.Data.forEach((element) => {
            if (element.MonthStatus === 1) {
              let temp = {
                Id: element.ItemId,
                Number: element.ItemNumber,
                Name: element.ItemName,
                MonthNumber:
                  this.editedMonthQuotation.Type === this.monthQuotationType.Discount
                    ? ''
                    : element.Number,
                Unit: element.ItemUnit,
                DiscountPrice: element.OriginalCurrency * 1,
                Discount: 0,
                PayQuantity: element.PayQuantity * 1,
                StopPayQuantity: 0,
                AddPayQuantity: 0,
                PayQuantityType: element.PayQuantityType,
                Quantity: element.OverageMonthQuantity * 1,
                RentQuantity: 1,
                Price: element.OriginalCurrency * 1,
                TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
                RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
                PayType: element.PayType,
                Remark: element.Remark,
                PayTimeRangeType: element.PayTimeRangeType,
                LicensePlate: element.LicensePlate
              }
              this.editedMonthQuotation.MonthItems.push(temp)
            }
          })
        }
        if (tempMonthItems.length > 0 && this.editedMonthQuotation.MonthItems.length === 0) {
          this.editedMonthQuotation.MonthItems = tempMonthItems
          this.editedMonthQuotation.MonthItems.forEach((element) => {
            element.MonthNumber = ''
          })
        }
      } else if (this.editedMonthQuotation.Type === this.monthQuotationType.RenewMonth) {
        let param = {
          customerId: this.editedMonthQuotation.Customer.Id,
          licensePlates: this.editedMonthQuotation.LicensePlateList.join(',')
        }

        let monthResponse = await HttpMonth.GetRenewMonthList(param)
        if (monthResponse && monthResponse.status === 200) {
          monthResponse.data.Data.forEach((element) => {
            let renewItemIndex = this.editedMonthQuotation.RenewMonthItems.findIndex(
              (x) => x.MonthNumber === element.Number
            )

            if (renewItemIndex === -1) {
              let renewMonthItemParam = {
                Number: element.ItemNumber,
                Name: element.ItemName,
                LicensePlate: element.LicensePlate,
                RentWarrantyPeriod: element.RentWarrantyPeriod,
                AddRentWarrantyPeriod: 0,
                TotalRentWarrantyPeriod: element.RentWarrantyPeriod,
                RenewReason: '',
                MonthNumber: element.Number
              }
              this.editedMonthQuotation.RenewMonthItems.push(renewMonthItemParam)
            } else {
              let renewMonthItemParam = this.editedMonthQuotation.RenewMonthItems[renewItemIndex]
              this.editedMonthQuotation.RenewMonthItems.splice(
                renewItemIndex,
                1,
                renewMonthItemParam
              )
            }
          })

          // 找出共同擁有的月租序號
          let validMonthNumbers = monthResponse.data.Data.map((element) => element.Number)

          // 刪除 RenewMonthItems 中不存在於 monthResponse.data.Data 的項目
          this.editedMonthQuotation.RenewMonthItems = this.editedMonthQuotation.RenewMonthItems.filter(
            (item) => validMonthNumbers.includes(item.MonthNumber)
          )
        }
      }
    },
    async searchMonthForOriginalLicensePlate () {
      this.warningMessage = []
      let param = {
        customerId: this.editedMonthQuotation.OriginalCustomer.Id,
        licensePlate: this.editedMonthQuotation.OriginalLicensePlate
      }

      let tempReturnMonthList = []
      let param2 = {
        customerId: this.editedMonthQuotation.Customer.Id,
        licensePlate: this.editedMonthQuotation.LicensePlate
      }
      let monthReturnResponse = await HttpMonth.GetMonthList(param2)
      if (monthReturnResponse && monthReturnResponse.status === 200) {
        tempReturnMonthList = monthReturnResponse.data.Data
      }

      if (this.editedMonthQuotation.Type === this.monthQuotationType.ReturnMonth) {
        let monthResponse = await HttpMonth.GetMonthList(param)
        let tempMonthItems = this.editedMonthQuotation.MonthItems
        this.editedMonthQuotation.MonthItems = []
        if (monthResponse && monthResponse.status === 200) {
          monthResponse.data.Data.forEach((element) => {
            let returnMonth = tempReturnMonthList.find(
              (x) => x.ItemId === element.ItemId && x.MonthStatus === 2
            )
            if (
              returnMonth &&
              this.editedMonthQuotation.LicensePlate !==
                this.editedMonthQuotation.OriginalLicensePlate
            ) {
              let temp = {
                Id: returnMonth.ItemId,
                Number: returnMonth.ItemNumber,
                Name: returnMonth.ItemName,
                MonthNumber: returnMonth.Number,
                Unit: returnMonth.ItemUnit,
                DiscountPrice: returnMonth.OriginalCurrency * 1,
                Discount: 0,
                Quantity: returnMonth.OverageMonthQuantity * 1,
                RentQuantity: 1,
                Price: returnMonth.OriginalCurrency * 1,
                TotalPrice: returnMonth.OverageMonthQuantity * returnMonth.OriginalCurrency * 1,
                RentWarrantyPeriod: returnMonth.RentWarrantyPeriod * 1,
                PayType: returnMonth.PayType,
                Remark: returnMonth.Remark,
                PayTimeRangeType: returnMonth.PayTimeRangeType,
                PayQuantity: returnMonth.PayQuantity * 1,
                StopPayQuantity: 0,
                AddPayQuantity: 0,
                PayQuantityType: returnMonth.PayQuantityType,
                LicensePlate: element.LicensePlate
              }
              this.editedMonthQuotation.MonthItems.push(temp)
              this.warningMessage.push(
                '車牌: ' +
                  this.editedMonthQuotation.LicensePlate +
                  ' 已有【' +
                  returnMonth.ItemName +
                  '】 已替換自己的序號 ' +
                  returnMonth.Number
              )
            } else {
              if (
                (element.PayType !== this.payType.Quantity && element.MonthStatus === 2) ||
                (element.PayType === this.payType.Quantity && element.MonthStatus === 1)
              ) {
                let temp = {
                  Id: element.ItemId,
                  Number: element.ItemNumber,
                  Name: element.ItemName,
                  MonthNumber: element.Number,
                  Unit: element.ItemUnit,
                  DiscountPrice: element.OriginalCurrency * 1,
                  Discount: 0,
                  Quantity: element.OverageMonthQuantity * 1,
                  RentQuantity: 1,
                  Price: element.OriginalCurrency * 1,
                  TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
                  RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
                  PayType: element.PayType,
                  Remark: element.Remark,
                  PayTimeRangeType: element.PayTimeRangeType,
                  PayQuantity: element.PayQuantity,
                  StopPayQuantity: 0,
                  AddPayQuantity: 0,
                  PayQuantityType: element.PayQuantityType,
                  LicensePlate: element.LicensePlate
                }
                this.editedMonthQuotation.MonthItems.push(temp)
              }
            }
          })
        }
        if (tempMonthItems.length > 0 && this.editedMonthQuotation.MonthItems.length === 0) {
          this.editedMonthQuotation.MonthItems = tempMonthItems
          this.editedMonthQuotation.MonthItems.forEach((element) => {
            let returnMonth = tempReturnMonthList.find(
              (x) => x.ItemId === element.Id && x.MonthStatus === 2
            )
            if (returnMonth) {
              element.Id = returnMonth.ItemId
              element.Number = returnMonth.ItemNumber
              element.Name = returnMonth.ItemName
              element.MonthNumber = returnMonth.Number
              element.Unit = returnMonth.ItemUnit
              element.DiscountPrice = returnMonth.OriginalCurrency * 1
              element.Discount = 0
              element.Quantity = returnMonth.OverageMonthQuantity * 1
              element.RentQuantity = 1
              element.Price = returnMonth.OriginalCurrency * 1
              element.TotalPrice =
                returnMonth.OverageMonthQuantity * returnMonth.OriginalCurrency * 1
              element.RentWarrantyPeriod = returnMonth.RentWarrantyPeriod * 1
              element.PayType = returnMonth.PayType
              element.Remark = returnMonth.Remark
              element.PayTimeRangeType = returnMonth.PayTimeRangeType
              element.PayQuantity = returnMonth.PayQuantity * 1
              element.StopPayQuantity = 0
              element.AddPayQuantity = 0
              element.PayQuantityType = returnMonth.PayQuantityType
              this.warningMessage.push(
                '車牌: ' +
                  this.editedMonthQuotation.LicensePlate +
                  ' 有【' +
                  returnMonth.ItemName +
                  '】 已加上自己的序號 ' +
                  returnMonth.Number
              )
            } else {
              element.MonthNumber = ''
            }
          })
        }
      } else if (this.editedMonthQuotation.Type === this.monthQuotationType.MoveMonth) {
        let monthResponse = await HttpMonth.GetMonthList(param)
        let tempMoveMonthItems = this.editedMonthQuotation.MoveMonthItems

        if (monthResponse && monthResponse.status === 200) {
          this.editedMonthQuotation.MoveMonthItems = []
          monthResponse.data.Data.forEach((element) => {
            let returnMonth = tempReturnMonthList.find(
              (x) => x.ItemId === element.ItemId && x.MonthStatus === 1
            )
            if (
              returnMonth &&
              this.editedMonthQuotation.LicensePlate !==
                this.editedMonthQuotation.OriginalLicensePlate
            ) {
              let temp = {
                Id: returnMonth.ItemId,
                Number: returnMonth.ItemNumber,
                Name: returnMonth.ItemName,
                MonthNumber: returnMonth.Number,
                Unit: returnMonth.ItemUnit,
                DiscountPrice: returnMonth.OriginalCurrency * 1,
                Discount: 0,
                Quantity: returnMonth.OverageMonthQuantity * 1,
                RemoveQuantity: 1,
                ReturnQuantity: 1,
                Price: returnMonth.OriginalCurrency * 1,
                TotalPrice: returnMonth.OverageMonthQuantity * returnMonth.OriginalCurrency * 1,
                RentWarrantyPeriod: returnMonth.RentWarrantyPeriod * 1,
                PayType: returnMonth.PayType,
                Remark: returnMonth.Remark,
                PayTimeRangeType: returnMonth.PayTimeRangeType,
                PayQuantity: returnMonth.PayQuantity,
                StopPayQuantity: 0,
                AddPayQuantity: 0,
                PayQuantityType: returnMonth.PayQuantityType,
                LicensePlate: element.LicensePlate
              }
              this.editedMonthQuotation.MoveMonthItems.push(temp)
              this.warningMessage.push(
                '車牌: ' +
                  this.editedMonthQuotation.LicensePlate +
                  ' 已有【' +
                  returnMonth.ItemName +
                  '】 已替換自己的序號 ' +
                  returnMonth.Number
              )
            } else {
              if (element.MonthStatus === 1) {
                let temp = {
                  Id: element.ItemId,
                  Number: element.ItemNumber,
                  Name: element.ItemName,
                  MonthNumber: element.Number,
                  Unit: element.ItemUnit,
                  DiscountPrice: element.OriginalCurrency * 1,
                  Discount: 0,
                  Quantity: element.OverageMonthQuantity * 1,
                  RemoveQuantity: 1,
                  ReturnQuantity: 1,
                  Price: element.OriginalCurrency * 1,
                  TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
                  RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
                  PayType: element.PayType,
                  Remark: element.Remark,
                  PayTimeRangeType: element.PayTimeRangeType,
                  PayQuantity: element.PayQuantity,
                  StopPayQuantity: 0,
                  AddPayQuantity: 0,
                  PayQuantityType: element.PayQuantityType,
                  LicensePlate: element.LicensePlate
                }
                this.editedMonthQuotation.MoveMonthItems.push(temp)
              }
            }
          })
        }
        if (
          tempMoveMonthItems.length > 0 &&
          this.editedMonthQuotation.MoveMonthItems.length === 0
        ) {
          this.editedMonthQuotation.MoveMonthItems = tempMoveMonthItems
          this.editedMonthQuotation.MoveMonthItems.forEach((element) => {
            let returnMonth = tempReturnMonthList.find(
              (x) => x.ItemId === element.Id && x.MonthStatus === 1
            )
            if (returnMonth) {
              element.Id = returnMonth.ItemId
              element.Number = returnMonth.ItemNumber
              element.Name = returnMonth.ItemName
              element.MonthNumber = returnMonth.Number
              element.Unit = returnMonth.ItemUnit
              element.DiscountPrice = returnMonth.OriginalCurrency * 1
              element.Discount = 0
              element.Quantity = returnMonth.OverageMonthQuantity * 1
              element.RemoveQuantity = 1
              element.ReturnQuantity = 1
              element.Price = returnMonth.OriginalCurrency * 1
              element.TotalPrice =
                returnMonth.OverageMonthQuantity * returnMonth.OriginalCurrency * 1
              element.RentWarrantyPeriod = returnMonth.RentWarrantyPeriod * 1
              element.PayType = returnMonth.PayType
              element.Remark = returnMonth.Remark
              element.PayTimeRangeType = returnMonth.PayTimeRangeType
              element.PayQuantity = returnMonth.PayQuantity
              element.StopPayQuantity = 0
              element.AddPayQuantity = 0
              element.PayQuantityType = returnMonth.PayQuantityType

              this.warningMessage.push(
                '車牌: ' +
                  this.editedMonthQuotation.LicensePlate +
                  ' 有【' +
                  returnMonth.ItemName +
                  '】 已加上自己的序號 ' +
                  returnMonth.Number
              )
            } else {
              element.MonthNumber = ''
            }
          })
        }
      } else if (this.editedMonthQuotation.Type === this.monthQuotationType.RenewMonth) {
        this.editedMonthQuotation.MonthItems = []
        let monthResponse = await HttpMonth.GetMonthList(param)
        if (monthResponse && monthResponse.status === 200) {
          monthResponse.data.Data.forEach((element) => {
            if (element.MonthStatus === 1) {
              let temp = {
                Id: element.ItemId,
                Number: element.ItemNumber,
                Name: element.ItemName,
                MonthNumber: element.Number,
                Unit: element.ItemUnit,
                DiscountPrice: element.OriginalCurrency * 1,
                Discount: 0,
                Quantity: element.OverageMonthQuantity * 1,
                RentQuantity: 1,
                Price: element.OriginalCurrency * 1,
                TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
                RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
                PayType: element.PayType,
                Remark: element.Remark,
                PayTimeRangeType: element.PayTimeRangeType,
                PayQuantity: element.PayQuantity,
                StopPayQuantity: 0,
                AddPayQuantity: 0,
                PayQuantityType: element.PayQuantityType,
                LicensePlate: element.LicensePlate
              }
              this.editedMonthQuotation.MonthItems.push(temp)
            }
          })
        }
      }
      if (this.warningMessage.length > 0) {
        alert(this.warningMessage)
      }
    },
    async getAllPayType () {
      let response = await HttpMonth.GetAllPayType()
      this.allPayType = response.status === 200 ? response.data.Data : []
    },
    setCarQuantity () {
      if (
        typeof this.editedMonthQuotation.LicensePlateList !== 'undefined' &&
        this.editedMonthQuotation.LicensePlateList.length !== 0
      ) {
        this.editedMonthQuotation.CarQuantity = this.editedMonthQuotation.LicensePlateList.length
      } else {
        this.editedMonthQuotation.CarQuantity = 1
      }
    },
    // 批量輸入車牌後同步原本 @change 會觸發的邏輯
    onBatchInputLicensePlate (newList) {
      this.editedMonthQuotation.LicensePlateList = newList
      this.setCarQuantity()
      this.searchMonthForLicensePlate()
    },
    turnTypeName (val) {
      return MonthQuotationType.MonthQuotationTypeName(val)
    },
    async setRemovedReason () {
      this.editedMonthQuotation.Name = this.editedMonthQuotation.Type.Name
      this.editedMonthQuotation.Type = this.editedMonthQuotation.Type.Type
      if (this.editedMonthQuotation.Type === this.monthQuotationType.RemoveMonth) {
        this.editedMonthQuotation.RemovedReason = 1
      } else {
        this.editedMonthQuotation.RemovedReason = 0
      }
      await this.getCustomerOriginalLicenseLicensePlateList()
      await this.getCustomerLicensePlateList()
    },
    setRenewMonthTime (val) {
      this.editedMonthQuotation.RenewMonthTime = val * 1
    },
    setMonthDoneTime (val) {
      this.editedMonthQuotation.MonthDoneTime = val * 1
    },
    setMonthSignTime (val) {
      this.editedMonthQuotation.MonthSignTime = val * 1
    },
    async throwMonth () {
      this.editedMonthQuotation.IsThrowMonth = true
      if (this.editedMonthQuotation.Type === this.monthQuotationType.NewMonth) {
        await HttpMonth.NewMonthItems(this.editedMonthQuotation)
        if (this.editedMonthQuotation.DiscountItems.length > 0) {
          await HttpDiscount.AddNewDiscountWithNewMonthQuotation(this.editedMonthQuotation)
          await HttpOverage.AddOverageFromMonthQuotation(this.editedMonthQuotation)
        }
      }
      if (
        this.editedMonthQuotation.Type === this.monthQuotationType.RemoveMonth ||
        this.editedMonthQuotation.Type === this.monthQuotationType.MoveMonth
      ) {
        await HttpMonth.RemoveMonthItems(this.editedMonthQuotation)
        await HttpDiscount.UpdateNewDiscountWithRemoveMonthQuotation(this.editedMonthQuotation)
        await HttpOverage.UpdateOverageFromRemoveMonthQuotation(this.editedMonthQuotation)
      }
      if (
        this.editedMonthQuotation.Type === this.monthQuotationType.ReturnMonth ||
        this.editedMonthQuotation.Type === this.monthQuotationType.MoveMonth
      ) {
        await HttpMonth.ReturnMonthItems(this.editedMonthQuotation)
        await HttpDiscount.UpdateNewDiscountWithReturnMonthQuotation(this.editedMonthQuotation)
        await HttpOverage.UpdateOverageFromReturnMonthQuotation(this.editedMonthQuotation)
      }

      if (this.editedMonthQuotation.Type === this.monthQuotationType.Discount) {
        await HttpDiscount.AddDiscountWithDiscountMonthQuotation(this.editedMonthQuotation)
      }

      if (this.editedMonthQuotation.Type === this.monthQuotationType.RenewMonth) {
        let response = await HttpMonth.UpdateRenewMonthFromMonthQuotation(
          this.editedMonthQuotation
        )
        if (
          response &&
          response.status === 200 &&
          this.editedMonthQuotation.OriginalCustomer &&
          this.editedMonthQuotation.OriginalCustomer.Number &&
          this.editedMonthQuotation.MonthItems &&
          this.editedMonthQuotation.MonthItems.length > 0
        ) {
          let removeMonthQuotation = {
            Type: 2,
            Customer: this.editedMonthQuotation.OriginalCustomer,
            OriginalCustomer: {
              Number: '',
              ShortName: '',
              Tel: '',
              Fax: '',
              Attribute: '',
              InvoiceAddress: '',
              CurrencyNo: '',
              InvoiceType: ''
            },
            CarQuantity: 1,
            RemovedReason: 3,
            LicensePlate: this.editedMonthQuotation.OriginalLicensePlate,
            LicensePlateList: [],
            OriginalLicensePlate: '',
            MonthItems: this.editedMonthQuotation.MonthItems,
            MoveMonthItems: [],
            DiscountItems: [],
            RenewMonthItems: [],
            IsThrowMonth: false,
            MonthDoneTime: 0,
            MonthSignTime: this.editedMonthQuotation.RenewMonthTime,
            RenewMonthTime: 0
          }
          await HttpMonthQuotation.AddMonthQuotation(removeMonthQuotation)
        }
      }
      await HttpMonthQuotation.UpdateMonthQuotation(this.editedMonthQuotation)
      await this.closeEditedMonthQuotation()
    },
    setRemovedReasonAutocomplete (event) {
      this.$refs.removedReasonAutocomplete.isMenuActive = false
      this.$refs.removedReasonAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setTypeAutocomplete (event) {
      this.$refs.typeAutocomplete.isMenuActive = false
      this.$refs.typeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },

    async setOriginalCustomer (val) {
      this.editedMonthQuotation.OriginalCustomer = JSON.parse(JSON.stringify(val))
      await this.searchMonthForLicensePlate()
      await this.searchMonthForOriginalLicensePlate()
    },
    async setCustomer (val) {
      this.editedMonthQuotation.Customer = JSON.parse(JSON.stringify(val))
      if (this.editedMonthQuotation.Type === this.monthQuotationType.UnlimitedMonth) {
        await this.getUnlimitedMonthList()
      } else {
        await this.getCustomerLicensePlateList()
        await this.searchMonthForLicensePlate()
        await this.searchMonthForOriginalLicensePlate()
      }
    },
    async setFilterOriginalCustomer (val) {
      this.filterMonthQuotation.OriginalCustomerId = val.Id
      this.filterMonthQuotation = JSON.parse(JSON.stringify(this.filterMonthQuotation))
      await this.getCustomerOriginalLicenseLicensePlateList()
      await this.getMonthQuotation()
      await this.countTotalRows()
    },
    async setFilterCustomer (val) {
      this.filterMonthQuotation.CustomerId = val.Id
      this.filterMonthQuotation = JSON.parse(JSON.stringify(this.filterMonthQuotation))
      await this.getMonthQuotation()
      await this.countTotalRows()
    },
    async getRemoveReason () {
      let response = await HttpQuotation.GetRemoveReasonTypes()
      this.allRemovedReason = response.status === 200 ? response.data.Data : []
    },

    copyMonthQuotation () {
      this.editedMonthQuotation.Number = ''
      this.editedMonthQuotationIndex = -1
      this.isAllTextFieldDisabled = false
      this.editedCopy = true
      this.editedMonthQuotation.Id = ''
      this.editedMonthQuotation.CreateTime = 0
      this.editedMonthQuotation.CreateBy = ''
      this.editedMonthQuotation.LicensePlateList = []
      this.editedMonthQuotation.OriginalLicensePlate = ''
      this.editedMonthQuotation.LicensePlate = ''
      this.editedMonthQuotation.IsThrowMonth = false
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getMonthQuotation(val)
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          Number: this.filterMonthQuotation.Number,
          Type: this.filterMonthQuotation.Type,
          CustomerId: this.filterMonthQuotation.CustomerId,
          OriginalCustomerId: this.filterMonthQuotation.OriginalCustomerId,
          LicensePlate: this.filterMonthQuotation.LicensePlate,
          OriginalLicensePlate: this.filterMonthQuotation.OriginalLicensePlate,
          IsThrowMonth: this.filterMonthQuotation.IsThrowMonth
        }

        let response = await HttpMonthQuotation.GetMonthQuotationCount(param)
        if (response) {
          this.totalRows = response.status === 200 ? response.data.Data : 0
        }
      }
    },
    async getMonthQuotationType () {
      this.isLoading = true

      let response = await HttpMonthQuotation.GetMonthQuotationTypes()
      if (response) {
        this.allMonthQuotationType = response.status === 200 ? response.data.Data : []
      }
      this.isLoading = false
    },
    async getMonthQuotation (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoading = true
      let param = {
        Number: this.filterMonthQuotation.Number,
        Type: this.filterMonthQuotation.Type,
        CustomerId: this.filterMonthQuotation.CustomerId,
        OriginalCustomerId: this.filterMonthQuotation.OriginalCustomerId,
        LicensePlate: this.filterMonthQuotation.LicensePlate,
        OriginalLicensePlate: this.filterMonthQuotation.OriginalLicensePlate,
        IsThrowMonth: this.filterMonthQuotation.IsThrowMonth,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc:
          typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortDesc[0]
      }

      let response = await HttpMonthQuotation.GetMonthQuotations(param)
      if (response) {
        this.monthQuotationList = response.status === 200 ? response.data.Data : []
      }
      this.isLoading = false
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    async isShowEditMonthQuotationDialogBtn (item) {
      this.editedMonthQuotationIndex = this.monthQuotationList.indexOf(item)
      this.editedMonthQuotation = JSON.parse(JSON.stringify(item))
      this.isAllTextFieldDisabled = this.editedMonthQuotation.IsThrowMonth
      await this.getCustomerLicensePlateList()
      if (
        this.editedMonthQuotation.Type === this.monthQuotationType.ReturnMonth ||
        this.editedMonthQuotation.Type === this.monthQuotationType.MoveMonth ||
        this.editedMonthQuotation.Type === this.monthQuotationType.RenewMonth
      ) {
        await this.getCustomerOriginalLicenseLicensePlateList()
      }
      this.isShowEditMonthQuotationDialog = true
    },
    isShowDeleteMonthQuotationDialogBtn (item) {
      this.editedMonthQuotationIndex = this.monthQuotationList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedMonthQuotation = JSON.parse(str)
      this.isShowDeleteMonthQuotationDialog = true
    },
    async closeEditedMonthQuotation () {
      this.isLoading = true
      await this.getMonthQuotation()
      this.isShowEditMonthQuotationDialog = false
      this.editedCopy = false
      this.isAllTextFieldDisabled = false
      this.isLoading = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultMonthQuotation)
        this.editedMonthQuotation = JSON.parse(str)
        this.editedMonthQuotationIndex = -1
      })
    },
    async confirmDeleteMonthQuotation () {
      this.isLoadingSaveBtn = true
      this.isAllTextFieldDisabled = true
      this.isLoading = true

      await HttpMonthQuotation.DeleteMonthQuotation(
        this.monthQuotationList[this.editedMonthQuotationIndex].Id
      )
      await this.getMonthQuotation()
      this.closeDeleteMonthQuotation()
    },
    closeDeleteMonthQuotation () {
      this.isShowDeleteMonthQuotationDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisabled = false
      this.isLoading = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultMonthQuotation)
        this.editedMonthQuotation = JSON.parse(str)
        this.editedMonthQuotationIndex = -1
      })
    },
    async saveEditedMonthQuotation () {
      const isValid = await this.$refs.dialog.validate()
      if (isValid) {
        // 驗證 RenewMonthItems 的合約期數
        if (
          this.editedMonthQuotation.MonthItems &&
          this.editedMonthQuotation.MonthItems.length > 0
        ) {
          // 按 ItemNumber 分組計算增加合約期數總和
          let renewItemGroups = {}
          this.editedMonthQuotation.RenewMonthItems.forEach((renewItem) => {
            if (!renewItemGroups[renewItem.Number]) {
              renewItemGroups[renewItem.Number] = 0
            }
            renewItemGroups[renewItem.Number] += renewItem.AddRentWarrantyPeriod || 0
          })

          // 檢查每個品號的增加合約期數總和是否小於原合約期數
          let errors = []
          for (let itemNumber in renewItemGroups) {
            let monthItem = this.editedMonthQuotation.MonthItems.find(
              (item) => item.Number === itemNumber
            )
            if (monthItem && renewItemGroups[itemNumber] < monthItem.RentWarrantyPeriod) {
              errors.push(
                `品號 ${itemNumber} 的增加合約期數總和 (${renewItemGroups[itemNumber]}) 已經小於原合約期數 (${monthItem.RentWarrantyPeriod})`
              )
            }
          }

          // 如果有錯誤，顯示所有錯誤訊息
          if (errors.length > 0) {
            alert(errors.join('\n'))
          }
        }

        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisabled = true

        if (this.editedMonthQuotationIndex !== -1) {
          await HttpMonthQuotation.UpdateMonthQuotation(this.editedMonthQuotation)
        } else {
          await HttpMonthQuotation.AddMonthQuotation(this.editedMonthQuotation)
        }

        await this.getMonthQuotation()
        this.isLoadingSaveBtn = false
        this.isAllTextFieldDisabled = false
        this.closeEditedMonthQuotation()
      }
    },
    setMonthItemIndex (val) {
      this.monthItemIndex = val
    },
    setAllMonth (items) {
      this.editedMonthQuotation.MonthItems = JSON.parse(JSON.stringify(items))
    },
    setBomMonth () {
      let totalPrice = 0
      let totalDiscount = 0
      this.editedMonthQuotation.MonthItems[this.monthItemIndex].MonthBomItems.forEach((element) => {
        totalPrice += element.Price * 1
        totalDiscount += element.Discount * 1
      })
      this.editedMonthQuotation.MonthItems[this.monthItemIndex].Price = totalPrice
      this.editedMonthQuotation.MonthItems[this.monthItemIndex].Discount = totalDiscount
      this.editedMonthQuotation.MonthItems[this.monthItemIndex].DiscountPrice =
        totalPrice - totalDiscount
      this.editedMonthQuotation.MonthItems[this.monthItemIndex].TotalPrice =
        this.editedMonthQuotation.MonthItems[this.monthItemIndex].DiscountPrice *
        this.editedMonthQuotation.MonthItems[this.monthItemIndex].Quantity *
        this.editedMonthQuotation.MonthItems[this.monthItemIndex].RentQuantity *
        1
      this.editedMonthQuotation.MonthItems = JSON.parse(
        JSON.stringify(this.editedMonthQuotation.MonthItems)
      )
    },
    setMonthItem (val) {
      if (this.monthItemIndex > -1) {
        this.editedMonthQuotation.MonthItems.splice(this.monthItemIndex, 1, val)
      } else {
        this.editedMonthQuotation.MonthItems.push(val)
      }
    },
    deleteMonthItem () {
      let monthItem = this.editedMonthQuotation.MonthItems[this.monthItemIndex]

      this.editedMonthQuotation.DiscountItems = this.editedMonthQuotation.DiscountItems.filter(
        (x) => x.MonthItemNumber !== monthItem.Number
      )

      this.editedMonthQuotation.MonthItems.splice(this.monthItemIndex, 1)
      if (this.editedMonthQuotation.MonthItems.length === 0) {
        this.editedMonthQuotation.DiscountItems = []
      }
    },
    setMonthBomItemIndex (val) {
      this.monthBomItemIndex = val
    },
    generateObjectId () {
      const timestamp = Math.floor(Date.now() / 1000)
        .toString(16)
        .padStart(8, '0')
      const randomBytes = Array.from({ length: 16 }, () =>
        Math.floor(Math.random() * 16).toString(16)
      ).join('')
      return timestamp + randomBytes
    },
    setDiscountItem (val) {
      if (this.discountItemIndex === -1) {
        if (val.DiscountType !== 2) {
          if (val.MonthItemId === '' || val.MonthItemId === null) {
            let monthList =
              this.editedMonthQuotation.Type === this.monthQuotationType.MoveMonth
                ? this.editedMonthQuotation.MoveMonthItems
                : this.editedMonthQuotation.MonthItems
            monthList.forEach((element) => {
              if (!element.Number) {
                element.MonthBomItems.forEach((ele) => {
                  this.editedMonthQuotation.DiscountItems.push({
                    DiscountId: this.generateObjectId(),
                    WaitForDiscountIds: val.WaitForDiscountIds,
                    DiscountType: val.DiscountType,
                    MonthWarrantyPeriod: ele.RentWarrantyPeriod,
                    MonthItemId: ele.Id,
                    MonthItemName: ele.Name,
                    MonthItemNumber: ele.Number,
                    IsRepeat: val.IsRepeat,
                    RepeatWarrantyPeriod: val.RepeatWarrantyPeriod,
                    GivePrepayment: val.GivePrepayment,
                    GiveWarrantyPeriod: val.GiveWarrantyPeriod,
                    GiveMoney: val.GiveMoney,
                    GiveDay: val.GiveDay,
                    GivePercent: val.GivePercent,
                    UseDiscountType: val.UseDiscountType,
                    UseWarrantyPeriods: val.UseWarrantyPeriods,
                    Remark: val.Remark,
                    Month: val.Month,
                    Months: val.Months
                  })
                })
              } else {
                if (!element.MonthNumber) {
                  this.editedMonthQuotation.DiscountItems.push({
                    DiscountId: this.generateObjectId(),
                    WaitForDiscountIds: val.WaitForDiscountIds,
                    DiscountType: val.DiscountType,
                    MonthWarrantyPeriod: element.RentWarrantyPeriod,
                    MonthItemId: element.Id,
                    MonthItemName: element.Name,
                    MonthItemNumber: element.Number,
                    IsRepeat: val.IsRepeat,
                    RepeatWarrantyPeriod: val.RepeatWarrantyPeriod,
                    GivePrepayment: val.GivePrepayment,
                    GiveWarrantyPeriod: val.GiveWarrantyPeriod,
                    GiveMoney: val.GiveMoney,
                    GivePercent: val.GivePercent,
                    GiveDay: val.GiveDay,
                    UseDiscountType: val.UseDiscountType,
                    UseWarrantyPeriods: val.UseWarrantyPeriods,
                    Remark: val.Remark,
                    Month: val.Month,
                    Months: val.Months
                  })
                }
              }
            })
          } else {
            val.DiscountId = this.generateObjectId()
            this.editedMonthQuotation.DiscountItems.push(val)
          }
        } else {
          val.DiscountId = this.generateObjectId()
          this.editedMonthQuotation.DiscountItems.push(val)
        }
      } else {
        this.editedMonthQuotation.DiscountItems.splice(this.discountItemIndex, 1, val)
      }
    },
    setDiscountItemIndex (val) {
      this.discountItemIndex = val
    },
    deleteDiscountItem (val) {
      this.editedMonthQuotation.DiscountItems.splice(val, 1)
    },
    setAllDiscount (items) {
      this.editedMonthQuotation.DiscountItems = JSON.parse(JSON.stringify(items))
    },

    async getCustomerOriginalLicenseLicensePlateList () {
      let param = {
        customerId: this.editedMonthQuotation.OriginalCustomer.Id,
        type: this.editedMonthQuotation.Type,
        isQuotation: false
      }
      let response = await HttpMonth.GetCustomerOriginalLicensePlateList(param)
      this.customerOriginalLicensePlateList = response.status === 200 ? response.data.Data : []
    },
    async getCustomerLicensePlateList () {
      let param = {
        customerId: this.editedMonthQuotation.Customer.Id,
        type: this.editedMonthQuotation.Type,
        isQuotation: false
      }
      let response = await HttpMonth.GetCustomerLicensePlateList(param)
      this.customerLicensePlateList = response.status === 200 ? response.data.Data : []
    },
    setMoveMonthItem (val) {
      if (this.monthItemIndex !== -1) {
        this.editedMonthQuotation.MoveMonthItems.splice(this.monthItemIndex, 1, val)
      } else {
        this.editedMonthQuotation.MoveMonthItems.push(val)
      }
    },
    deleteMoveMonthItem () {
      let monthItem = this.editedMonthQuotation.MoveMonthItems[this.monthItemIndex]

      this.editedMonthQuotation.DiscountItems = this.editedMonthQuotation.DiscountItems.filter(
        (x) => x.MonthItemNumber !== monthItem.Number
      )

      this.editedMonthQuotation.MoveMonthItems.splice(this.monthItemIndex, 1)
      if (this.editedMonthQuotation.MoveMonthItems.length === 0) {
        this.editedMonthQuotation.DiscountItems = []
      }
    },
    setAllMoveMonth (items) {
      this.editedMonthQuotation.MoveMonthItems = JSON.parse(JSON.stringify(items))
    },
    setEditedRenewMonthItemIndex (val) {
      this.renewMonthItemIndex = val
    },
    setEditedRenewMonthItem (val) {
      if (this.renewMonthItemIndex !== -1) {
        this.editedMonthQuotation.RenewMonthItems.splice(this.renewMonthItemIndex, 1, val)
      } else {
        this.editedMonthQuotation.RenewMonthItems.push(val)
      }
    },
    deleteRenewMonthItem () {
      this.editedMonthQuotation.RenewMonthItems.splice(this.renewMonthItemIndex, 1)
    }
  }
}
</script>
